import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

export const ACTION_REQUEST_TRANSACTION = 'ACTION_REQUEST_TRANSACTION';

export const REQUEST_TRANSACTIONS = 'REQUEST_TRANSACTIONS';
export const REQUEST_TRANSACTION_SUCCESS = 'REQUEST_TRANSACTION_SUCCESS';
export const REQUEST_TRANSACTION_FAILURE = 'REQUEST_TRANSACTION_FAILURE';

// GET categories
export const REQUEST_GET_CATEGORIES = 'REQUEST_GET_CATEGORIES';
export const REQUEST_GET_CATEGORIES_SUCCESS = 'REQUEST_GET_CATEGORIES_SUCCESS';
export const REQUEST_GET_CATEGORIES_FAILURE = 'REQUEST_GET_CATEGORIES_FAILURE';
export const ACTION_GET_CATEGORIES = 'ACTION_GET_CATEGORIES';

export const UPDATE_FILTER = 'UPDATE_FILTER';

const defaultState = {
  transactionFilter: {
    limit: 10,
    page: 1,
    q: '',
  },

  transactions: [],
  totalTransaction: 0,
  fetchingTransaction: true,
  failedFetchingTransaction: false,

  //Get marketplace categories
  category: {},
  categoryError: {},
  fetchingMarketplace: false,
  failedFetchingMarketplace: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_TRANSACTIONS]: (state, _action) => ({
    ...state,
    fetchingTransaction: true,
    failedFetchingTransaction: false,
  }),

  [REQUEST_TRANSACTION_SUCCESS]: (state, action) => ({
    ...state,
    totalTransaction: action?.payload?.data?.total || 1,
    transactions: action?.payload?.data?.items || [],
    fetchingTransaction: false,
    failedFetchingTransaction: false,
  }),

  [REQUEST_TRANSACTION_FAILURE]: (state, _action) => ({
    ...state,
    fetchingTransaction: false,
    failedFetchingTransaction: true,
  }),

  [UPDATE_FILTER]: (state, _action) => ({
    ...state,
    transactionFilter: _action.payload,
  }),
  // GET marketplace
  [REQUEST_GET_CATEGORIES]: (state) => ({
    ...state,
    fetchingMarketplace: true,
    failedFetchingMarketplace: false,
  }),
  [REQUEST_GET_CATEGORIES_SUCCESS]: (state, action) => ({
    ...state,
    category: action.payload,
    fetchingMarketplace: false,
    failedFetchingMarketplace: false,
  }),
  [REQUEST_GET_CATEGORIES_FAILURE]: (state, action) => ({
    ...state,
    categoryError: action.payload,
    fetchingMarketplace: false,
    failedFetchingMarketplace: true,
  }),
});

export default reducer;
export const namespace = 'transaction';

export const actionUpdateFilter = (filters) => ({
  type: UPDATE_FILTER,
  payload: filters,
});
export const actionGetTransaction = () => ({
  type: ACTION_REQUEST_TRANSACTION,
});

export const actionRequestMarketplace = () => ({
  type: ACTION_GET_CATEGORIES,
});

export const getTransactions = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/transactions',
    actionTypes: [REQUEST_TRANSACTIONS, REQUEST_TRANSACTION_SUCCESS, REQUEST_TRANSACTION_FAILURE],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const getCategoriesAPI = (marketplaceData) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'categories/marketplace?page=1&limit=49',
    actionTypes: [
      REQUEST_GET_CATEGORIES,
      REQUEST_GET_CATEGORIES_SUCCESS,
      REQUEST_GET_CATEGORIES_FAILURE,
    ],
    variables: {
      ...marketplaceData,
    },
    dispatch,
    getState,
  });
};
